<template>
   <InstituteProfile :profileDetails="profileDetails" :enrolledTutors="enrolledTutors"/>
</template>
<script setup>
import InstituteProfile from "@/views/adminPublicProfile/instituteProfile.vue";
import { defineProps } from "vue";
defineProps({
   profileDetails: null,
   enrolledTutors: null,
})
</script>
<style scoped>

</style>